import gql from 'graphql-tag';
import { apolloClient } from '../apolloClient.js';

let portfoliosPromise;
export const GET_PORTFOLIOS = gql`
  {
    portfolios {
      id
      name
      createDate
      updateDate
      entities {
        id
      }
      issuers {
        id
      }
      transactions {
        id
        type
      }
      issues {
        id
      }
      infraProjects {
        id
      }
      permissions {
        permissionId
        resourceType
        permission
        resourceId
        granteeType
        granteeId
      }
      effectivePermissions {
        resourceType
        resourceId
        permission
      }
      isIssueBased
    }
  }
`;

export function getPortfolios() {
  return portfoliosPromise;
}

export function refetchPortfolios() {
  return (portfoliosPromise = apolloClient
    .query({ query: GET_PORTFOLIOS })
    .then((res) => {
      return res.data.portfolios;
    })
    .catch(() => {
      throw new Error('Portfolio API returned unsuccessful');
    }));
}

export const triggerPortfolioChangeEvent = () =>
  window.dispatchEvent(new CustomEvent('portfolioChange'));
